import { render, staticRenderFns } from "./greenfilmdocs.vue?vue&type=template&id=23b895da&scoped=true&"
import script from "./greenfilmdocs.vue?vue&type=script&lang=js&"
export * from "./greenfilmdocs.vue?vue&type=script&lang=js&"
import style0 from "./greenfilmdocs.vue?vue&type=style&index=0&id=23b895da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b895da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b895da')) {
      api.createRecord('23b895da', component.options)
    } else {
      api.reload('23b895da', component.options)
    }
    module.hot.accept("./greenfilmdocs.vue?vue&type=template&id=23b895da&scoped=true&", function () {
      api.rerender('23b895da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/greenfilm/greenfilmdocs.vue"
export default component.exports